/**
 * @author Leonel Martinez
 * @module modals
 * @fileoverview `Vuex modals module`
 * @see ModalLoader.vue in the shared components folder
 */
export const modals = {
  namespaced: true,
  state: {
    // List of all available modals in the app
    modals: {
      c2c: false,
      editVehicle: false,
      loadQuote: false,
      intSearch: false,
      partsSearch: false,
      intWildcards: false,
      intHelp: false,
      SCQ: false,
      graphicsUrl: false
    }
  },
  getters: {
    modals: state => state.modals,
  },
  actions: {
    /**
     * @description Toggles the modal state
     * @param {string} name points directly to the state name of the components
     * @param {boolean} value true or false.
     * @see state modals
     */
    TOGGLE_MODAL_STATE: ({ commit }, { name, value }) => {
      commit('SET_MODAL_STATE', { name, value });
    }
  },
  mutations: {
    SET_MODAL_STATE: (state, { name, value }) => {
      state.modals[name] = value;
    }
  }
}
